<div
  class="row section-row section mt-3"
  formGroupName="addendum"
  *ngIf="feedbackTypeAllowed()"
>
  <div class="section-container">
    <div class="row section-row">
      <div class="col section-col">
        <h5 class="section-heading">Addendum</h5>
      </div>
    </div>
    <div class="row section-row">
      <div class="col-6 section-col">
        <app-yes-no
          [id]="formElementModels['addendumCompletedAtHospital'].id"
          [formElementModel]="formElementModels['addendumCompletedAtHospital']"
          [parentFormGroup]="formGroup"
        ></app-yes-no>
      </div>
    </div>
    <div class="row section-row" *ngIf="showAddendumDetails">
      <div class="col-12 section-col">
        <app-rich-text-editor
          [id]="formElementModels['addendumDetails'].id"
          [formElementModel]="formElementModels['addendumDetails']"
          [parentFormGroup]="formGroup"
        ></app-rich-text-editor>
      </div>
    </div>
    <div class="row section-row" *ngIf="showElrAddendumRequired">
      <div class="col-6 section-col">
        <app-yes-no
          [id]="formElementModels['elrAddendumRequired'].id"
          [formElementModel]="formElementModels['elrAddendumRequired']"
          [parentFormGroup]="formGroup"
        ></app-yes-no>
      </div>
    </div>
  </div>
</div>
